// This loads jQuery (automatically found in /node_modules/jquery)
global.$ = global.jQuery = require('jquery');

// Loads required libs
import 'svg4everybody';
import 'jquery-validation';
import 'magnific-popup';

import Search from "../../../../src/js/components/common/Search";

import Alert from "./modules/alert";
import statusMessage from "./modules/statusMessage";

new Search();
let msg = new statusMessage();

// let workingBtn = document.querySelector('.jsBtnWorking');
// let readyBtn = document.querySelector('.jsBtnReady');

// workingBtn.addEventListener('click', () => {
//     msg.working();
//     msg.text('This is a custom working message')
// });

// readyBtn.addEventListener('click', () => {
//     msg.ready();
//     msg.text('This is a custom ready message')
// });


// let alertContent = {
//     heading: "A heading 2",
//     body: "<p>This is a paragraph</p>"
// }

// let alertSettings = {
//     parentElement: '.donation-form',
//     position: "cover", // cover / inline
//     type: "error", // error / warning / success / info
// }

// let myAlert = new Alert(alertSettings, alertContent);

// myAlert.show();

// document.querySelector('body').addEventListener('click', () => {
//     console.log("Body clicked");
//     myAlert.hide()
// } );
// document.querySelector('body').addEventListener('dblclick', () => {
//     console.log("Body double-clicked");
//     myAlert.show()
// } );
// myAlert.hide();

require('mailcheck');
require('chosen-js');

(function ($)
{

	// Init vars
	var discoveredReaders
	var clientSecret
	var paymentIntentId
	var frequency
	var subscriptionId
	var customerId
	var readerId = document.getElementById('reader-id').value
	var readerConnectionStatus
	var readerMode = document.getElementById('reader-mode').value
	var readerLabel = document.getElementById('reader-label').value
	var selectedReader
	var terminal = StripeTerminal.create({
	  onFetchConnectionToken: fetchConnectionToken,
	  onUnexpectedReaderDisconnect: unexpectedDisconnect,
	})
	var errMsg = '[01] We encountered a problem processing your donation. Please refresh your browser and try again.'

	// Read the msg object
	// msg.ready()
	msg.mode('success');
	msg.icon('icon-check');

	// Handle catched errors
	function errorHandler(error)
	{

		/*
			Connection Errors:
			Unable to connect to the reader: tmr_EJpwRwOqnWdCcv
			ReferenceError: config is not defined
		*/

		// Logging
		console.log('errorHandler')

		if ( error.message )
		error.message

		// Set the error message
		errMsg = error.toString()

		// Turn off loading state
		$('.-reloading')
			.removeClass('-reloading')
			.children('.btn__inner')
			.text('Pay by Card');

		let alertContent = {
			heading: "Oops, there was a problem!",
			body: `<p>${error}</p>`
		}

		let alertSettings = {
			parentElement: '.donation-form',
			disableElement: '.allFormElements', // must be a valid recipient of the `disabled` property
			position: "cover", // cover / inline
			// type: "error", // error / warning / success / info
		}

		let errorAlert = new Alert(alertSettings, alertContent);

		// Show alert
		errorAlert.show('fast');

		// Log error
		let username = 'b9lDJ1ugLzIk'
		let password = 'vbuScRC2CfnD'
		let url = `/make-gift/logError.php`
		let authString = `${username}:${password}`
		let headers = new Headers();

		// Set headers
		headers.set('Authorization', 'Basic ' + btoa(authString))
		headers.set('Content-Type', 'application/json')

		// Build json data
		let bodyContent = JSON.stringify({
			errMsg: errMsg,
			payment_intent_id: paymentIntentId,
			customer_id: customerId,
			subscription_id: subscriptionId,
			reader_id: readerId
		})

		// Log error
		fetch('/make-gift/logError.php', {
			method: 'POST',
			headers: headers,
			body: bodyContent
		})
		.catch(function(){console.log(error)})
	} // errorHandler(error)

	// Handle unexpected disconnect
	function unexpectedDisconnect()
	{
	  // In this function, your app should notify the user
	  // that the reader disconnected. You can also include
	  // a way to attempt to reconnect to a reader.
	  errorHandler("[01] Unexpectedly disconnected from reader. Please try refreshing your browser.")
	} // unexpectedDisconnect()

	// Fetch the connection token
	function fetchConnectionToken()
	{

		let username = 'b9lDJ1ugLzIk';
		let password = 'vbuScRC2CfnD';
		let url = `/make-gift/fetchConnectionToken.php`
		let authString = `${username}:${password}`
		let headers = new Headers();

		headers.set('Authorization', 'Basic ' + btoa(authString))

		// Do not cache or hardcode the ConnectionToken.
		// The SDK manages the ConnectionToken's lifecycle.
		return fetch(url, {
			method: 'POST',
			headers: headers
		})
		.then(function(response) {
			return response.json()
		})
		.then(function(data) {
			if ( data.secret )
			{
				return data.secret
			}
			else
			{
				throw new Error('Failed to generate a connection token to connect to the reader.')
			}
		})
		.catch(errorHandler)
	} // fetchConnectionToken()

	// Create or update a customer and start
	// payment intent on terminal
	function initializePayment(
		frequency,
		amount,
		// billingFirstName,
		// billingLastName,
		email,
		phone,
		billingCountry,
		// billingState,
		// billingZip,
		// billingCity,
		// billingAddress,
		campaignId,
		fmv,
		sourceChannel,
		responseChannel,
		version,
		donationLevel,
		coverTransactionFees,
		giftProcessor,
		redirectTo
	)
	{

		return new Promise((resolve, reject) => {

			// Logging
			console.log('initializePayment')

			// Build json data
			let bodyContent = JSON.stringify({
				frequency: frequency,
				amount: amount,
				// billing_first_name: billingFirstName,
				// billing_last_name: billingLastName,
				email: email,
				phone: phone,
				billing_country: billingCountry,
				// billing_state: billingState,
				// billing_zip: billingZip,
				// billing_city: billingCity,
				// billing_address: billingAddress,
				campaign_id: campaignId,
				fmv: fmv,
				source_channel: sourceChannel,
				response_channel: responseChannel,
				version: version,
				donation_level: donationLevel,
				cover_transaction_fees: coverTransactionFees,
				gift_processor: giftProcessor,
				redirect_to: redirectTo
			})

			fetch('/make-gift/initializePayment.php', {
				method: "POST",
				headers: {
					'Content-Type': 'application/json'
				},
				body: bodyContent
			})
			.then(function(response) {
				return response.json()
			})
			.then(function(data) {
				if ( data.client_secret )
				{
					customerId = data.customer_id
					paymentIntentId = data.payment_intent_id
					clientSecret = data.client_secret
					frequency = data.frequency
					resolve(clientSecret)
				}
				else
				{
					if ( data.error )
					{
						reject(new Error(data.error))
					}
					else
					{
						reject(new Error("[02] We encountered a problem processing your donation. Please refresh your browser and try again."))
					}
				}
			})
			//.catch(errorHandler)
		})
	} // initializePayment(...)

	$('.-reload-page').click(function() {
		// Cancel the donation payment method
		console.log('paymentStatus')
		switch ( terminal.getPaymentStatus() )
		{
			case 'waiting_for_input':
			case 'processing':
				terminal.cancelCollectPaymentMethod()
		}
		$(this)
			.addClass('-reloading')
			.children('span')
			.text('Reloading…')
		location.reload()
		return false
	});

	function collectPayment(clientSecret)
	{
		// Logging
		console.log('collectPayment')

		msg.text('Please wait until the amount appears on the card reader, then tap, insert or swipe your card.')

		// Testing
		if ( readerMode == 'sim' )
		{
			terminal.setSimulatorConfiguration({testCardNumber: '6011111111111117'})
		}

		console.log('collectPaymentMethod')
		terminal.collectPaymentMethod(clientSecret)
			.then(function(result)
			{
				msg.text('Processing the donation…')

                // Troubleshooting
                // console.log('collectPaymentMethod--result')
                // console.log(result)
                // return

				if (result.error)
				{
					// Placeholder for handling result.error
					// console.log("Error: " + result.error);
					// console.log('collectPaymentMethod-result.error')
					// console.log(result.error)
					if ( result.error.code )
					{
						if ( result.error.code == 'canceled')
						{
							msg.text('Canceling the donation.')
						}
						else
						{
							errMsg = '[' + result.error.code + '] '
							if ( result.error.message )
							{
								errMsg += result.error.message
							}
							else
							{
								switch ( result.error.code )
								{
									case 'command_already_in_progress':
										errMsg += 'Payment intent already in process.'
										break;

									case 'reader_error':
										errMsg += 'There was a problem with the reader while processing payment.'
										break;

									default:
										errMsg += 'Unexpected error processing payment.'
								}
							}

							throw new Error(errMsg)
						}

					}
					else
					{
						throw new Error(result.error)
					}
				}
				else
				{
					if ( frequency == 'monthly' )
					{
						if ( country != 'US' )
						{
							throw new Error('Currently it is not possible to setup recurring payments with a non-US credit card from a card reader.')
						}

						// Set the Payment Intent 
						paymentIntentId = result.paymentIntent.id;
						msg.text('Thank you! You will now be redirected to the confirmation page.');
						$('#make-gift-button').removeAttr('disabled').click();						
					}
					else
					{
						terminal.processPayment(result.paymentIntent)
						.then(function(result)
						{
                            // console.log('processPayment-result')
                            // console.log(result)
                            // return
							if (result.error)
							{
								// console.log('processPayment-result.error')
								// console.log(result.error)
								if ( result.error.message )
								{
									throw new Error(result.error.message)
								}
								else
								{
									throw new Error(result.error)
								}
							}
							else if (result.paymentIntent)
							{
								paymentIntentId = result.paymentIntent.id;
								msg.text('Thank you! You will now be redirected to the confirmation page.');
								$('#make-gift-button').removeAttr('disabled').click();
							}
						})
						.catch(errorHandler)
					}
				}
			})
			.catch(errorHandler)
	} // collectPayment(clientSecret)

	function finalizePayment(
		paymentIntentId,
		customerId,
		frequency,
		amount,
		// firstName,
		// lastName,
		email,
		phone,
		campaignId,
		fmv,
		sourceChannel,
		responseChannel,
		version,
		donationLevel,
		coverTransactionFees,
		giftProcessor,
		redirectTo
	)
	{

		// Logging
		console.log('finalizePayment')

		// Build json data
		let bodyContent = JSON.stringify({
			payment_intent_id: paymentIntentId,
			customer_id: customerId,
			frequency: frequency,
			amount: amount,
			// billing_first_name: firstName,
			// billing_last_name: lastName,
			email: email,
			phone: phone,
			campaign_id: campaignId,
			fmv: fmv,
			source_channel: sourceChannel,
			response_channel: responseChannel,
			version: version,
			donation_level: donationLevel,
			cover_transaction_fees: coverTransactionFees,
			gift_processor: giftProcessor,
			redirect_to: redirectTo
		})

		// Finalize Payment
		return fetch('/make-gift/finalizePayment.php', {
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			body: bodyContent
		})
		.then(function(response) {
			return response.json()
		})
		.then(function(data) {

			if ( data.error )
			{
				throw Error(data.error)
			}
			else
			{
				// Reset the form
				document.getElementById("payment-form").reset()

				if ( data.redirect_to )
				{
					// Build URL
					var strURLParams = "";
					// Payment Intent Id
					if ( data.payment_intent_id )
					{
					    strURLParams += strURLParams === "" ? "?" : "&";
					    strURLParams += "id=" + encodeURIComponent(data.payment_intent_id);
					}
                    // Subscription Id
                    if ( data.subscription_id )
                    {
                        strURLParams += strURLParams === "" ? "?" : "&";
                        strURLParams += "sid=" + encodeURIComponent(data.subscription_id);
                    }                    
					// Amount
					if ( data.amount )
					{
						strURLParams += strURLParams === "" ? "?" : "&";
						strURLParams += "amount=" + encodeURIComponent(data.amount);
					}
					// Frequency
					if ( data.frequency )
					{
						strURLParams += strURLParams === "" ? "?" : "&";
						strURLParams += "frequency=" + encodeURIComponent(data.frequency);
					}
					window.location.href = data.redirect_to + strURLParams;
				}
				else
				{

				}
			}

		})
		.catch(errorHandler)
	} // finalizePayment(...)


	// jQuery helper functions
	$.fn.visible = function() {
		return this.css('visibility', 'visible');
	};

	$.fn.invisible = function() {
		return this.css('visibility', 'hidden');
	};

	$.fn.visibilityToggle = function() {
		return this.css('visibility', function(i, visibility) {
			return (visibility == 'visible') ? 'hidden' : 'visible';
		});
	};

	// Main
	$(document).ready(function ()
	{

		// Fadeout the loading
		$(".loading").fadeOut(200);

		// Reset any outstanding payment
		switch ( terminal.getPaymentStatus() )
		{
			case 'waiting_for_input':
			case 'processing':
				terminal.cancelCollectPaymentMethod()
		}

		// Set page 2 next button(s) to connecting
		// Will remove once the reader has finished connecting
		$('.jsPage2')
			.addClass('-reloading -connecting')
			.children('.btn__inner')
			.text('Connecting…')

		// Handling the payment form
		if ( $("#payment-form").length )
		{
			// Init
			var $form = $("#payment-form");
			var donation_initialized = false;
			var linkHandler = false;

			// $(".jsChosenSelect").chosen({width:"100%"});

			// Discover the readers
			const discoverReaderHandler = () => {
				return new Promise((resolve, reject) => {

					// Config terminal to simulate or not
					var config;
					if ( readerMode == 'sim' )
					{
						config = {simulated: true}
					}
					else
					{
						config = {simulated: false}
					}

					// Fetch the discovered readers
					terminal.discoverReaders(config)
						.then(function(discoverResult)
						{
							if (discoverResult.error)
							{
								reject(new Error('Failed to discover: ' + discoverResult.error))
							}
							else if (discoverResult.discoveredReaders.length === 0)
							{
								reject(new Error('No available readers.'))
							}
							else
							{
								resolve(discoverResult.discoveredReaders)
							}
						})
						.catch(errorHandler)
				})
			}

			// Handler for a "Connect Reader" button
			const connectReaderHandler = (discoveredReaders) => {

				// Select the allocated Reader
				if ( readerMode == 'sim' )
				{
					selectedReader = discoveredReaders[0]
				}
				else
				{
					discoveredReaders.forEach(function (reader, index) {
					  if ( reader.id === readerId )
						selectedReader = reader;
					});
				}
				// Check if a selected reader was set
				if ( !selectedReader )
				{
					throw new Error('Unable to connect to the reader: ' + readerId)
				}

				// Connect to the reader
				terminal.connectReader(selectedReader)
					.then(function(connectResult)
					{
						// Logging
						console.log('connectReader')

						// Handle reader connect result
						if (connectResult.error)
						{
							throw new Error('Failed to connect: ', connectResult.error)
						}
						else
						{
							// console.log('Connected to reader: ', connectResult.reader.label);
							// Update the reader status message to connected
							$('#reader-status').text('Connected to ' + readerLabel)
							// Set Page 2 'Pay by Card' button to active state
							$('.jsPage2')
								.removeClass('-reloading -connecting')
								.children('.btn__inner')
								.text('Pay by Card')
						}
					})
					.catch(errorHandler)
			}

			// Next donation page
			function nextPage( $button, data )
			{
				// Logging
				console.log('nextPage')

				// Advance to the next page
				changePage( $button.attr("href") );
			} // nextPage(...)

			// Connect to Reader
			discoverReaderHandler()
				.then(connectReaderHandler)
				.catch(errorHandler)

			$(".jsVisibleAmount").focus();

			function isNumber(n) {
				return !isNaN(parseFloat(n)) && isFinite(n);
			}

			/*
 ######  ##     ##  ######    ######   ########  ######  ######## ######## ########
##    ## ##     ## ##    ##  ##    ##  ##       ##    ##    ##    ##       ##     ##
##       ##     ## ##        ##        ##       ##          ##    ##       ##     ##
 ######  ##     ## ##   #### ##   #### ######    ######     ##    ######   ##     ##
	  ## ##     ## ##    ##  ##    ##  ##             ##    ##    ##       ##     ##
##    ## ##     ## ##    ##  ##    ##  ##       ##    ##    ##    ##       ##     ##
 ######   #######   ######    ######   ########  ######     ##    ######## ########

   ###    ##     ##  #######  ##     ## ##    ## ########    ########  ######## ##    ##
  ## ##   ###   ### ##     ## ##     ## ###   ##    ##       ##     ##    ##    ###   ##
 ##   ##  #### #### ##     ## ##     ## ####  ##    ##       ##     ##    ##    ####  ##
##     ## ## ### ## ##     ## ##     ## ## ## ##    ##       ########     ##    ## ## ##
######### ##     ## ##     ## ##     ## ##  ####    ##       ##     ##    ##    ##  ####
##     ## ##     ## ##     ## ##     ## ##   ###    ##       ##     ##    ##    ##   ###
##     ## ##     ##  #######   #######  ##    ##    ##       ########     ##    ##    ##
				Suggested Amount buttons
				-------------------------------------------------------------
			*/
			$(".jsSuggestedAmounts button[value]").on("click touchstart", function()
			{
				$('.jsSuggestedAmounts button').removeClass('selected');
				$(this).addClass('selected');
				$(this).parents("form")
					.find(".jsVisibleAmount")
					.val( $(this).val() )
					.trigger("input")
					.valid();
			});
			// End Suggested Amounts

			/*
 ######  #### ##    ##  ######   ##       ########          ##
##    ##  ##  ###   ## ##    ##  ##       ##               ##
##        ##  ####  ## ##        ##       ##              ##
 ######   ##  ## ## ## ##   #### ##       ######         ##
	  ##  ##  ##  #### ##    ##  ##       ##            ##
##    ##  ##  ##   ### ##    ##  ##       ##           ##
 ######  #### ##    ##  ######   ######## ########    ##

##     ##  #######  ##    ## ######## ##     ## ##       ##    ##
###   ### ##     ## ###   ##    ##    ##     ## ##        ##  ##
#### #### ##     ## ####  ##    ##    ##     ## ##         ####
## ### ## ##     ## ## ## ##    ##    ######### ##          ##
##     ## ##     ## ##  ####    ##    ##     ## ##          ##
##     ## ##     ## ##   ###    ##    ##     ## ##          ##
##     ##  #######  ##    ##    ##    ##     ## ########    ##
				Single/Monthly Donation Options
				-------------------------------------------------------------
			*/

			// Check the single/monthly option and show/hide buttons accordingly.
			function checkSingleMonthlyTab()
			{
				if ( $(".jsTabAnnually").prop("checked") )
				{
					// Annually
					$(".jsAchPopup").addClass("active");
					var minAnnually = $(".jsVisibleAmount").data("minAnnually");
					$(".jsVisibleAmount").attr({
						"min": minAnnually
						// "placeholder": "Minimum monthly donation $" + minMonthly
					});
					// Show the correct amounts label (suggested amounts)
					// $(".amounts-label").hide();
					// $(".non-amounts-label").show();
					// Show the correct interval label
					$(".donation-type--text").text('Annually');
					// Show the correct tab
					$(".frequency-single").hide();
					$(".frequency-monthly").show();
					// Hide amount buttons
					// $(".button--amounts").invisible();
					$(".amt-opts__single-monthly").invisible();
					$(".amt-opts__annually").visible();
				}
				else if ( $(".jsTabMonthly").prop("checked") )
				{
					// Monthly
					$(".jsAchPopup").addClass("active");
					var minMonthly = $(".jsVisibleAmount").data("minMonthly");
					$(".jsVisibleAmount").attr({
						"min": minMonthly
						// "placeholder": "Minimum monthly donation $" + minMonthly
					});
					// Show the correct amounts label (suggested amounts)
					// $(".amounts-label").show();
					// $(".non-amounts-label").hide();
					// Show the correct interval label
					$(".donation-type--text").text('Monthly');
					// Show the correct tab
					$(".frequency-single").hide();
					$(".frequency-monthly").show();
					// Show amount buttons
					// $(".button--amounts").visible();
					$(".amt-opts__annually").invisible()
					$(".amt-opts__single-monthly").visible();
				}
				else
				{
					// Single
					$(".jsAchPopup").removeClass("active");
					var minSingle = $(".jsVisibleAmount").data("minSingle");
					$(".jsVisibleAmount").attr({
						"min": minSingle
						// "placeholder": "Minimum donation $" + minSingle
					});
					// Show the correct amounts label (suggested amounts)
					// $(".amounts-label").show();
					// $(".non-amounts-label").hide();
					// Show the correct interval label
					$(".donation-type--text").text('One-time');
					// Show the correct tab
					$(".frequency-monthly").hide();
					$(".frequency-single").show();
					// Show amount buttons
					// $(".button--amounts").visible();
					$(".amt-opts__annually").invisible();
					$(".amt-opts__single-monthly").visible();
				}
			}

			// On first page load, run the check to take into account hard-coded "Monthly-only" cases.
			checkSingleMonthlyTab();

			// Also run the check whenever a tab is changed.
			$("[name=frequency]").change(function()
			{
				// Check if donation meets Freedom Partner requirements
				fpQualify();

				checkSingleMonthlyTab();
			});
			// End Single/Monthly Donation Options

			/*
######## ########     ###    ##    ##  ######     ###     ######  ######## ####  #######  ##    ##
   ##    ##     ##   ## ##   ###   ## ##    ##   ## ##   ##    ##    ##     ##  ##     ## ###   ##
   ##    ##     ##  ##   ##  ####  ## ##        ##   ##  ##          ##     ##  ##     ## ####  ##
   ##    ########  ##     ## ## ## ##  ######  ##     ## ##          ##     ##  ##     ## ## ## ##
   ##    ##   ##   ######### ##  ####       ## ######### ##          ##     ##  ##     ## ##  ####
   ##    ##    ##  ##     ## ##   ### ##    ## ##     ## ##    ##    ##     ##  ##     ## ##   ###
   ##    ##     ## ##     ## ##    ##  ######  ##     ##  ######     ##    ####  #######  ##    ##

######## ######## ########  ######
##       ##       ##       ##    ##
##       ##       ##       ##
######   ######   ######    ######
##       ##       ##             ##
##       ##       ##       ##    ##
##       ######## ########  ######
				Cover Transaction Fees
				--------------------------------------------------------------
			*/
			// init
			// $(".jsTransactionFees .is-checked").hide(); // done via CSS
			var targetAmount = null;

			/**
			 *
			 * @param {Number} targetAmount This is the original amount the
			 * donor intended to give, before covering transaction fees.
			 */
			function applyFees(targetAmount)
			{
				var fees = ( (parseFloat(targetAmount) * 0.019) + 0.3 ).toFixed(2);
				var newAmount = (parseFloat(targetAmount) + parseFloat(fees)).toFixed(2);

				// Update elements that show user what the fees amount is
				$(".jsTransactionFees b").html("$" + fees);

				// Update field that actually gets submitted
				$(".jsTotalAmount").val(newAmount);

				// Show fees
				$('.jsTransactionFees .not-checked').hide();
				$('.jsTransactionFees .is-checked').show();

				// Update Donation Summary table total
				// $(".jsDonationTotal").html("$" + newAmount);

				// Show Donation Summary table Fees & Total rows
				// $(".donation-summary__fees, .donation-summary__total")
				//     .removeClass("is-hidden");
			}

			/**
			 *
			 * @param {Number} targetAmount This is the original amount the donor
			 * intended to give, before covering transaction fees.
			 */
			function removeFees(targetAmount)
			{
				$(".jsTransactionFees b").html("");
				// $(".jsTotalAmount, .jsVisibleAmount").val(targetAmount);
				$(".jsTotalAmount").val(targetAmount);
				// console.log("Original Amount: " + targetAmount);

				// Hide fees
				$('.jsTransactionFees .is-checked').hide();
				$('.jsTransactionFees .not-checked').show();

				// Update Donation Summary table total
				// $(".jsDonationTotal").html("");

				// Show Donation Summary table Fees & Total rows
				// $(".donation-summary__fees, .donation-summary__total")
				//     .addClass("is-hidden");
			}

			// When input amount changes
			$(".jsVisibleAmount").on("input", function()
			{
				// Get provided amount
				targetAmount = parseFloat(this.value).toFixed(2);
				// Keep amount field that actually gets submitted in
				// sync with visible amount
				$(".jsTotalAmount").val(targetAmount);
				$(".jsDonationBase").html("$" + targetAmount);
				// If we're covering fees
				if ( $(".jsCoverFees").is(":checked") && isNumber( $('.jsVisibleAmount').val() ) )
				{
					// Apply fees to the total amount field
					applyFees( targetAmount );
				}
				else
				{
				  removeFees( targetAmount );
				}
			});

			// When donor chooses to cover transaction fees
			$(".jsCoverFees").change(function()
			{
				// Get provided amount
				targetAmount = parseFloat($("#target-amount").val()).toFixed(2);

				if ( isNumber( $(".jsVisibleAmount").val() ) )
				{
					if ( $(this).is(":checked") )
					{
						applyFees(targetAmount);
						// $('.jsTransactionFees .not-checked').hide();
						// $('.jsTransactionFees .is-checked').show();
					}
					else
					{
						removeFees(targetAmount);
						// $('.jsTransactionFees .is-checked').hide();
						// $('.jsTransactionFees .not-checked').show();
					}
				}
			});
			// End Cover Transaction Fees


			/*
######## ########      ######   #######  ##        #######  ########   ######
##       ##     ##    ##    ## ##     ## ##       ##     ## ##     ## ##    ##
##       ##     ##    ##       ##     ## ##       ##     ## ##     ## ##
######   ########     ##       ##     ## ##       ##     ## ########   ######
##       ##           ##       ##     ## ##       ##     ## ##   ##         ##
##       ##           ##    ## ##     ## ##       ##     ## ##    ##  ##    ##
##       ##            ######   #######  ########  #######  ##     ##  ######
				Freedom Partner indication
				--------------------------------------------------------------
			*/

			function fpQualify()
			{
				if ( ($(".jsTabMonthly").prop("checked"))
					&& ($(".jsVisibleAmount").val() >= 24) )
				{
					$(".jsDonationForm").addClass("freedom-partner");
				}
				else if ( ($(".jsTabAnnually").prop("checked"))
					&& ($(".jsVisibleAmount").val() >= 288) )
				{
					$(".jsDonationForm").addClass("freedom-partner");
				}
				else
				{
					$(".jsDonationForm").removeClass("freedom-partner");
				}
			}

			$(".jsVisibleAmount").on("input", fpQualify );
			// End Freedom Partner indication

			/**
##     ##    ###    ##       #### ########     ###    ######## ####  #######  ##    ##
##     ##   ## ##   ##        ##  ##     ##   ## ##      ##     ##  ##     ## ###   ##
##     ##  ##   ##  ##        ##  ##     ##  ##   ##     ##     ##  ##     ## ####  ##
##     ## ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ## ## ##
 ##   ##  ######### ##        ##  ##     ## #########    ##     ##  ##     ## ##  ####
  ## ##   ##     ## ##        ##  ##     ## ##     ##    ##     ##  ##     ## ##   ###
   ###    ##     ## ######## #### ########  ##     ##    ##    ####  #######  ##    ##
			 * Form Validation
			 * --------------------------------------------------------------
			 */
			var validator = $form.validate();


			/*
########  #######  ########  ##     ##    ########     ###     ######   ########  ######
##       ##     ## ##     ## ###   ###    ##     ##   ## ##   ##    ##  ##       ##    ##
##       ##     ## ##     ## #### ####    ##     ##  ##   ##  ##        ##       ##
######   ##     ## ########  ## ### ##    ########  ##     ## ##   #### ######    ######
##       ##     ## ##   ##   ##     ##    ##        ######### ##    ##  ##             ##
##       ##     ## ##    ##  ##     ##    ##        ##     ## ##    ##  ##       ##    ##
##        #######  ##     ## ##     ##    ##        ##     ##  ######   ########  ######
				Form Pages
				--------------------------------------------------------------
			*/
			// Init
			$(".jsFormPage").first()
				.addClass("active")
				.siblings(".jsFormPage")
				.addClass("inactive");

			function changePage(page)
			{
				$(".jsFormPage" + page ).addClass("active")
					.removeClass("inactive")
					.siblings(".jsFormPage")
					.removeClass("active")
					.addClass("inactive")
					.find("input.error")
					.removeClass("error");

				// Disable the CC Name field if that page isn"t active to prevent it
				// from being submitted if the donor selected to use the ACH option.
				if ( $("#form-page--3").hasClass("active") )
				{
					$('#cc_first_name').prop('disabled', false);
					$('#cc_last_name').prop('disabled', false);
				}
				else
				{
					$('#cc_first_name').prop('disabled', true);
					$('#cc_last_name').prop('disabled', true);
				}

				// Smoothly scroll to put the form into view
				document.querySelector('#payment-form').scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}

			// Pagination
			$(".jsPrevPage").on("click touchstart", function(e)
			{
				e.preventDefault();
				changePage( $(this).attr("href") );
			});

			$(".jsNextPage").on("click touchstart", function(e)
			{
				e.preventDefault();

				if ( $form.valid() )
				{

					if ( $(this).hasClass("disabled") )
					{
						return false;
					}


					if ( $(this).hasClass("give-btn") )
					{
						var strGiveBtn = $(this).data("givebtn");

						// Hide unused give buttons
						$(".give-btns").hide();

						// Show active give button
						$("."+strGiveBtn).show();

						if ( strGiveBtn == "give-monthly-bank-btn" )
						{
							$("#plaid-captcha-wrap").show();
						}
						else
						{
							$("#plaid-captcha-wrap").hide();
						}
					}

					// If on Page 1, advance to Page 2
					if ( $(this).hasClass("jsPage1") )
					{
						changePage( $(this).attr("href") );
					}

					// Handle starting a payment (donation)
					if ( $(this).hasClass("jsPage2") )
					{

						if ( $(this).hasClass('-connecting')
							|| $(this).hasClass('-reloading') )
							return

						$(this)
							.addClass('-reloading')
							.children('.btn__inner')
							.text('Processing…');
						// return; // used to debug the line above

						// Fetch or create a Customer first
						let frequency = $('[name=frequency]:checked').val()
						let amount = $('[name=amount]').val()
						// let firstName = $('[name=billing_first_name]').val()
						// let lastName = $('[name=billing_last_name]').val()
						let email = $('[name=email]').val()
						let phone = $('[name=phone]').val()
						let country = $('[name=billing_country]').val()
						// let state = $('[name=billing_state]').val()
						// let zip = $('[name=billing_zip]').val()
						// let city = $('[name=billing_city]').val()
						// let address = $('[name=billing_address]').val()
						let campaignId = $('[name=campaign_id]').val()
						let fmv = $('[name=fmv]').val()
						let sourceChannel = $('[name=source_channel]').val()
						let responseChannel = $('[name=responseChannel]').val()
						let version = $('[name=version]').val()
						let donationLevel = $('[name=donation_level]').val()
                        var coverTransactionFees = 'no'
                        if ( $("[name=cover_transaction_fees]:checked").val() == 'yes' )
                            coverTransactionFees = 'yes'
						let giftProcessor = $('[name=gift_processor]').val()
						let redirectTo = $('[name=redirect_to]').val()

						initializePayment(
							frequency,
							amount,
							//firstName,
							//lastName,
							email,
							phone,
							country,
							//state,
							// zip,
							//city,
							//address,
							campaignId,
							fmv,
							sourceChannel,
							responseChannel,
							version,
							donationLevel,
							coverTransactionFees,
							giftProcessor,
							redirectTo
						)
							.then(collectPayment)
							.then(nextPage.bind(null, $(this)))
							.catch(errorHandler);

					}

				}
			});
			// End Form Pages

			/**
##    ##    ###    ##     ## ########     ######  ##        #######  ##    ## ########
###   ##   ## ##   ###   ### ##          ##    ## ##       ##     ## ###   ## ##
####  ##  ##   ##  #### #### ##          ##       ##       ##     ## ####  ## ##
## ## ## ##     ## ## ### ## ######      ##       ##       ##     ## ## ## ## ######
##  #### ######### ##     ## ##          ##       ##       ##     ## ##  #### ##
##   ### ##     ## ##     ## ##          ##    ## ##       ##     ## ##   ### ##
##    ## ##     ## ##     ## ########     ######  ########  #######  ##    ## ########
			/**
			 * Name Clone
			 * ------------------------------------------------------------------------
			 * Copies First Name & Last Name from page 2 to Page 3
			 */

			//  First Name
			$("[name=billing_first_name]").on('input change', function ()
			{
				var fname = $(this).val();
				$('[name=cc_first_name]').val(fname);
			})

			// Last Name
			$("[name=billing_last_name]").on('input change', function ()
			{
				var lname = $(this).val();
				$('[name=cc_last_name]').val(lname);
			})


			/**
##     ##    ###    #### ##        ######  ##     ## ########  ######  ##    ##
###   ###   ## ##    ##  ##       ##    ## ##     ## ##       ##    ## ##   ##
#### ####  ##   ##   ##  ##       ##       ##     ## ##       ##       ##  ##
## ### ## ##     ##  ##  ##       ##       ######### ######   ##       #####
##     ## #########  ##  ##       ##       ##     ## ##       ##       ##  ##
##     ## ##     ##  ##  ##       ##    ## ##     ## ##       ##    ## ##   ##
##     ## ##     ## #### ########  ######  ##     ## ########  ######  ##    ##
			 * MailCheck
			 * ------------------------------------------------------------------------
			 */

			//  var domains = ["gmail.com", "aol.com", "yahoo.com", "hotmail.com","msn.com"];
			//  var secondLevelDomains =
			$(".jsMailcheck").on("blur", function ()
			{
				$(this).mailcheck({
					suggested: function(element, suggestion)
					{
						$(element)
							.addClass('has-possible-typo')
							.siblings(".jsSuggestedEmailBox")
							.find(".jsSuggestedEmailAddress")
							.val(suggestion.full)
							.html(suggestion.address + '@<strong>' + suggestion.domain + '</strong>')
							.closest(".jsSuggestedEmailBox")
							.fadeIn(200);
					},
					empty: function(element)
					{
						// alert("stuff!");
						$(element)
							.removeClass('has-possible-typo')
							.siblings(".jsSuggestedEmailBox")
							.fadeOut(200);
					}
				});
			});

			// Use suggested email correction
			$(".jsSuggestedEmailAddress").on("click", function(e)
			{
				e.preventDefault();
				$(this).closest(".jsSuggestedEmailBox").fadeOut(200).siblings(".jsMailcheck").val($(this).val()).removeClass('has-possible-typo');
				$(this).closest("form").validate().element(".jsMailcheck");
			});

			// Close suggested email box
			$('.jsSuggestedEmailClose').on('click', function()
			{
			  $(this)
				.closest('.jsSuggestedEmailBox')
				.fadeOut(200)
				.siblings(".jsMailcheck")
				.removeClass('has-possible-typo');
			});

			/**
 #######  ######## ######## ##       #### ##    ## ########
##     ## ##       ##       ##        ##  ###   ## ##
##     ## ##       ##       ##        ##  ####  ## ##
##     ## ######   ######   ##        ##  ## ## ## ######
##     ## ##       ##       ##        ##  ##  #### ##
##     ## ##       ##       ##        ##  ##   ### ##
 #######  ##       ##       ######## #### ##    ## ########

 ######   #### ##     ## #### ##    ##  ######
##    ##   ##  ##     ##  ##  ###   ## ##    ##
##         ##  ##     ##  ##  ####  ## ##
##   ####  ##  ##     ##  ##  ## ## ## ##   ####
##    ##   ##   ##   ##   ##  ##  #### ##    ##
##    ##   ##    ## ##    ##  ##   ### ##    ##
 ######   ####    ###    #### ##    ##  ######
			 * Offline Giving page
			 * ------------------------------------------------------------------------
			 * Predefined fields (readonly) that are editable if need be
			 */
			$(".jsClickToEdit").on("click", function()
			{
				$(this).attr({
					"readonly": null,
					"title": null
				})
				.removeClass("jsClickToEdit");
			});

			$(".jsChosenSelect").chosen({width:"100%"});

			// AJAX close
			$("#ajax-close").on("click", function(event)
			{
				event.preventDefault();
				$("#ajax-response").fadeOut(300);
				$("#ajax-message").hide();
				$(this).hide();
				$("#ajax-processing").show();
			});
/*
########  #######   #######  ######## ######## ########
##       ##     ## ##     ##    ##    ##       ##     ##
##       ##     ## ##     ##    ##    ##       ##     ##
######   ##     ## ##     ##    ##    ######   ########
##       ##     ## ##     ##    ##    ##       ##   ##
##       ##     ## ##     ##    ##    ##       ##    ##
##        #######   #######     ##    ######## ##     ##

 ######  ########    ###    ########   ######  ##     ##
##    ## ##         ## ##   ##     ## ##    ## ##     ##
##       ##        ##   ##  ##     ## ##       ##     ##
 ######  ######   ##     ## ########  ##       #########
	  ## ##       ######### ##   ##   ##       ##     ##
##    ## ##       ##     ## ##    ##  ##    ## ##     ##
 ######  ######## ##     ## ##     ##  ######  ##     ##
 */

 $('.jsSearch').on('click', function ()
 {
	$('.jsSearchPanel').toggleClass('opened');
 })

			/**
 ######  ######## ########  #### ########  ########
##    ##    ##    ##     ##  ##  ##     ## ##
##          ##    ##     ##  ##  ##     ## ##
 ######     ##    ########   ##  ########  ######
	  ##    ##    ##   ##    ##  ##        ##
##    ##    ##    ##    ##   ##  ##        ##
 ######     ##    ##     ## #### ##        ########
			 * HANDLE STRIPE
			 */

			$form.submit(function(event)
			{
				event.preventDefault();
				if ( $(this).valid() )
				{
					// Logging
					console.log('submitPayment');

					// Handle Stripe captcha
					if ( $("#stripeCaptchaResponse").val() == "" )
					{
						grecaptcha.execute(stripeCaptcha);
					}
					else
					{

						// Fetch values
						let frequency = $('[name=frequency]:checked').val()
						let amount = $('[name=amount]').val()
						// let firstName = $('[name=billing_first_name]').val()
						// let lastName = $('[name=billing_last_name]').val()
						let email = $('[name=email]').val()
						let phone = $('[name=phone]').val()
						// let country = $('[name=billing_country]').val()
						// let state = $('[name=billing_state]').val()
						// let zip = $('[name=billing_zip]').val()
						// let city = $('[name=billing_city]').val()
						// let address = $('[name=billing_address]').val()
						let campaignId = $('[name=campaign_id]').val()
						let fmv = $('[name=fmv]').val()
						let sourceChannel = $('[name=source_channel]').val()
						let responseChannel = $('[name=responseChannel]').val()
						let version = $('[name=version]').val()
						let donationLevel = $('[name=donation_level]').val()
                        var coverTransactionFees = 'no'
                        if ( $("[name=cover_transaction_fees]:checked").val() == 'yes' )
                            coverTransactionFees = 'yes'						
						let giftProcessor = $('[name=gift_processor]').val()
						let redirectTo = $('[name=redirect_to]').val()

						// Start finalizing the payment
						finalizePayment(
							paymentIntentId,
							customerId,
							frequency,
							amount,
							// firstName,
							// lastName,
							email,
							phone,
							campaignId,
							fmv,
							sourceChannel,
							responseChannel,
							version,
							donationLevel,
							coverTransactionFees,
							giftProcessor,
							redirectTo
						)
						.catch(errorHandler)

					}

				}

			});

		}

	});

/*
##     ##    ###     ######   ##    ## #### ######## ####  ######
###   ###   ## ##   ##    ##  ###   ##  ##  ##        ##  ##    ##
#### ####  ##   ##  ##        ####  ##  ##  ##        ##  ##
## ### ## ##     ## ##   #### ## ## ##  ##  ######    ##  ##
##     ## ######### ##    ##  ##  ####  ##  ##        ##  ##
##     ## ##     ## ##    ##  ##   ###  ##  ##        ##  ##    ##
##     ## ##     ##  ######   ##    ## #### ##       ####  ######

########   #######  ########  ##     ## ########
##     ## ##     ## ##     ## ##     ## ##     ##
##     ## ##     ## ##     ## ##     ## ##     ##
########  ##     ## ########  ##     ## ########
##        ##     ## ##        ##     ## ##
##        ##     ## ##        ##     ## ##
##         #######  ##         #######  ##
*/


		if ( $(".popup").length )
		{
			$(".popup").magnificPopup({
				type: "iframe",
				// Delay in milliseconds before popup is removed
				removalDelay: 300,

				// Class that is added to popup wrapper and background
				// make it unique to apply your CSS animations just to this exact popup
				mainClass: "mfp-fade",
				// closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>'
				closeMarkup: '<button title="%title%" type="button" class="mfp-close"><svg class="icon icon-close" viewBox="0 0 32 32"><path d="M31.414 28.586l-28-28-2.828 2.828 28 28z"></path><path d="M3.414 31.414l28-28-2.828-2.828-28 28z"></path></svg></button>'
			});
		}

}(jQuery));

window.onLoadCallback = function()
{
	// Stripe Captcha
	window.stripeCaptcha = grecaptcha.render('stripe-captcha', {
		sitekey: '6LfymKYUAAAAABK35ZzfOkJqk6mMQ3b778prHTNd',
		size: "invisible",
		badge: "inline",
		callback: onStripeSubmit
	});
	// // Plaid Captcha
	// window.plaidCaptcha = grecaptcha.render('plaid-captcha', {
	// 	sitekey: '6Le466YUAAAAACuKByz611Z5eG855YiFDUNC9IsU',
	// 	size: "invisible",
	// 	badge: "inline",
	// 	callback: onPlaidSubmit
	// });
}


window.onStripeSubmit = function(response)
{

  //   // Trigger submit
  //   // var response = grecaptcha.getResponse();
	document.getElementById('stripe-captcha-response').value = response;
	$("#payment-form").trigger('submit');

}


// window.onPlaidSubmit = function(response)
// {

// 	// Trigger submit
// 	document.getElementById('plaid-captcha-response').value = response;
// 	$("#linkButton").trigger('click');

// }